import React, { useContext } from 'react';
import {
	IEditModGroupRestaurantPropertiesContext,
	EditModGroupRestaurantPropertiesContext,
} from '../../../../../editModGroupRestaurantPropertiesState/editModGroupRestaurantPropertiesContext';
import { Form } from 'antd';
import { ValidateFields } from 'rc-field-form/es/interface';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './BtnBlock.module.scss';

interface IProps {
	revalidateForm: ValidateFields;
}

export const BtnBlock: React.FC<IProps> = ({ revalidateForm }) => {
	const { changeTypeOfModalWindow, IDSelectedRestaurant } = useContext<IEditModGroupRestaurantPropertiesContext>(
		EditModGroupRestaurantPropertiesContext,
	);

	const handleSaveAsPatch = () => {
		if (IDSelectedRestaurant) {
			changeTypeOfModalWindow('saveAsPatch');
		} else {
			revalidateForm();
		}
	};

	return (
		<Form.Item>
			<div className={style.container} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" onClick={handleSaveAsPatch}>
					<Text translationNameSpace="form" translationKey="saveAsPatchButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit">
					<Text translationNameSpace="form" translationKey="saveLocalChangesButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};
